import { ApolloClient } from 'apollo-client'
import { onError } from 'apollo-link-error'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
// import { Hermes } from 'apollo-cache-hermes'
import { setContext } from 'apollo-link-context'
import { persistCache } from 'apollo-cache-persist'

import { store } from '../App'
import { logout } from './Actions/Account'

/**
  * authErrorLink
  * @desc onError for auth event handler
  * @param {graphQLError} graphQLErrors
  * @param {networkError} networkError looking for a 401 error
*/
const authErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError && networkError.statusCode === 401) {
    store.dispatch(logout())
  }
})

const httpLink = new HttpLink({ uri: `https://${process.env.REACT_APP_WINTERGREEN_HOST}/graphql` })
// const httpLink = new HttpLink({ uri: 'http://localhost:8080/graphql' })

/**
  * authLink setContext
  * @desc retrieve authHeaders and pass them into state
  * @return {Object} state authHeaders in a state format
  */
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = store.getState().account.token
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null
    }
  }
})

const cache = new InMemoryCache()

persistCache({
  cache,
  storage: window.localStorage
})
//
// const cache = new Hermes()

/**
  * ApolloClient
  * @desc ApolloClient generator
  * @param {ApolloClientOptions} options Object like single param
*/
const client = new ApolloClient({
  link: authErrorLink.concat(authLink.concat(httpLink)),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  }
})

export default client
